// Individual icons sliced from the supplied icons.png sprite (transparent PNGs).
import codeMonitor from "../assets/icons/code-monitor.png";
import people3 from "../assets/icons/people3.png";
import cloud from "../assets/icons/cloud.png";
import codeWindow from "../assets/icons/code-window.png";
import storefront from "../assets/icons/storefront.png";
import browserImage from "../assets/icons/browser-image.png";
import serverStack from "../assets/icons/server-stack.png";
import growthBars from "../assets/icons/growth-bars.png";
import lightbulb from "../assets/icons/lightbulb.png";
import peopleCollab from "../assets/icons/people-collab.png";
import layers from "../assets/icons/layers.png";
import lineGrowth from "../assets/icons/line-growth.png";

export const ICONS = {
    codeMonitor,
    people3,
    cloud,
    codeWindow,
    storefront,
    browserImage,
    serverStack,
    growthBars,
    lightbulb,
    peopleCollab,
    layers,
    lineGrowth,
};

export function SpriteIcon({ src, alt = "", className = "", size = 56 }) {
    return (
        <img
            src={src}
            alt={alt}
            width={size}
            height={size}
            loading="lazy"
            style={{ width: size, height: size }}
            className={`object-contain ${className}`}
        />
    );
}
